import { render, staticRenderFns } from "./ayden.vue?vue&type=template&id=b5b0eecc&scoped=true"
import script from "./ayden.vue?vue&type=script&lang=js"
export * from "./ayden.vue?vue&type=script&lang=js"
import style0 from "./ayden.vue?vue&type=style&index=0&id=b5b0eecc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b0eecc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5b0eecc')) {
      api.createRecord('b5b0eecc', component.options)
    } else {
      api.reload('b5b0eecc', component.options)
    }
    module.hot.accept("./ayden.vue?vue&type=template&id=b5b0eecc&scoped=true", function () {
      api.rerender('b5b0eecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pay/ayden.vue"
export default component.exports